import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HGSAgentType } from "src/app/constants/agent";
import { Genders } from "src/app/constants/genders";
import { MaskType } from "src/app/constants/masks";
import { TaxStaus } from "src/app/constants/tax-status";
import { USStates } from "src/app/constants/us-states";
import { FormValidationService } from "src/app/services/form-validation.service";

@Component({
    selector: 'mwp-agent-sass-mat-form',
    templateUrl: './sass-mat-form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SassMatFormComponent implements OnInit {

    public matForm: FormGroup;
    public maskType = MaskType;
    public genders = Genders;
    public usStates = USStates;
    public hgsAgentType = HGSAgentType;
    public taxStatus = TaxStaus;
    public signatureValid: boolean;

    constructor(
        private formBuilder: FormBuilder,
    ){
    }

    ngOnInit(): void {
      this.matForm = this.formBuilder.group({
            textBox: [null, Validators.required],
            textBox2: ['MWP TEST'],
            textBoxDisabled: [{value: 'Text Box Disabled', disabled: true}, Validators.required],
            
            phone: [null, [Validators.required, Validators.compose([FormValidationService.validPhoneNumber(true)])]],
            phone2: [1234567890],
            phoneDisabled: [{value: 1234567890, disabled: true}, [Validators.required, Validators.compose([FormValidationService.validPhoneNumber(true)])]],

            social: [null, [Validators.required, Validators.compose([FormValidationService.validLast4SSN(true)])]],
            socialLast4: [null, Validators.compose([FormValidationService.validLast4SSN(true)])],
            socialDisabled: [{value: '098765432', disabled: true}, [Validators.required, Validators.compose([FormValidationService.validPhoneNumber(true)])]],
            socialLas4Disabled: [{value: '4567', disabled: true},],

            dropDown: [null],
            dropDownRequired: ['M', Validators.required],
            dropDownDisabled: [{value: 'VT', disabled: true}, Validators.required],

            date: [null],
            dateRequired: ['09/15/2025', Validators.compose([FormValidationService.validMaterialDate(true)])],
            dateDisabled: [{value: '5-23-2123', disabled: true}, Validators.required],

            textarea: [null],
            textareaRequired: ["This is just a test of required text area", Validators.required],
            textareaDisabled: [{value: "Text Area is Disabled and non editable!", disabled: true}, Validators.required],
        });
    }
}